import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { store, persistor } from "../redux/store";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import RouteControls from "./RouteControls";
import { setupAutoLogout, isTokenExpired, performLogout } from "../utils/tokenManager";

function App() {
  useEffect(() => {
    const accessToken = sessionStorage.getItem("token");
    const isAuthenticated = sessionStorage.getItem("isAuthenticated");

    if (accessToken && isAuthenticated === "true") {
      if (isTokenExpired(accessToken)) {
        performLogout();
      } else {
        setupAutoLogout(accessToken);
      }
    }
  }, []);

  // disable zoom for ipad and mobile
  useEffect(() => {
    const handleGestureStart = event => {
      event.preventDefault();
    };
    document.addEventListener("gesturestart", handleGestureStart);
    return () => {
      document.removeEventListener("gesturestart", handleGestureStart);
    };
  }, []);

  window.addEventListener("error", e => {
    if (e.message === "ResizeObserver loop completed with undelivered notifications." || e.message === "ResizeObserver loop limit exceeded") {
      const resizeObserverErrDiv = document.getElementById("webpack-dev-server-client-overlay-div");
      const resizeObserverErr = document.getElementById("webpack-dev-server-client-overlay");
      if (resizeObserverErr) {
        resizeObserverErr.setAttribute("style", "display: none");
      }
      if (resizeObserverErrDiv) {
        resizeObserverErrDiv.setAttribute("style", "display: none");
      }
    }
  });

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastContainer autoClose={2000} hideProgressBar={true} closeOnClick />
        <RouteControls />
      </PersistGate>
    </Provider>
  );
}

export default App;
